import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { ListLazyComponents } from '@enums';
import { TranslocoModule } from '@ngneat/transloco';
import { InputSearchWrapperFieldModule } from '../..';
import { ApplicationRoutingService } from '@application-routing';

@Component({
  selector: 'fake-search-btn',
  templateUrl: './fake-search.component.html',
  styleUrls: ['./fake-search.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FakeSearchComponent {

  constructor(
    private readonly routingService: ApplicationRoutingService,
    private readonly router: Router
  ) { }

  public toSearch(): void {
    this.routingService.navigate(ListLazyComponents.search, this.router.routerState.snapshot.url);
  }

}

@NgModule({
  declarations: [FakeSearchComponent],
  exports: [
    FakeSearchComponent
  ],
  imports: [
    CommonModule,
    InputSearchWrapperFieldModule,
    TranslocoModule
  ]
})
export class FakeSearchModule { }
